import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Company from "./views/Company.vue";

Vue.use(Router);

export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			name: "home",
			component: Home
		},
		{
			path: "/company",
			name: "company",
			component: Company
		},
		{
			path: "/business",
			name: "business",
			redirect: "/portfolio"
		},
		{
			path: "/portfolio",
			name: "portfolio",
			component: () => import("./views/Portfolio.vue")
		},
		{
			path: "/portfolio/:si",
			name: "portfoliosi",
			component: () => import("./views/Portfolio.vue")
		},
		{
			path: "/portfolio/:web",
			name: "portfolioweb",
			component: () => import("./views/Portfolio.vue")
		},
		{
			path: "/portfolio/:mobile",
			name: "portfoliomobile",
			component: () => import("./views/Portfolio.vue")
		},
		{
			path: "/portfolio/:proposal",
			name: "portfolioproposal",
			component: () => import("./views/Portfolio.vue")
		},
		{
			path: "/solution",
			name: "solution",
			component: () => import("./views/Solution.vue")
		},
		{
			path: "/solution/:id",
			name: "solutions",
			component: () => import("./views/solution/solutions.vue")
		},
		{
			path: "/news",
			name: "news",
			component: () => import("./views/News.vue")
		},
		{
			path: "/career",
			name: "career",
			component: () => import("./views/Career.vue")
		},
		{
			path: "/industrytrends",
			name: "industrytrends",
			component: () => import("./views/IndustryTrends.vue")
		},
		{
			path: "/cs",
			name: "customerservice",
			component: () => import("./views/CustomerService.vue")
		},
		{
			path: "/boardview",
			name: "boardview",
			component: () => import("./views/BoardView.vue"),
			props: true
		},
		{
			path: "/boardtemplate",
			name: "boardviewtemplate",
			component: () => import("./views/BoardTemplate.vue"),
			props: true
		},
		{
			path: "*",
			name: "errorPage",
			component: () => import("./views/error/404.vue"),
			props: true
		}
	],
	/* 라우터 기본 이동 시 스크롤 상단 고정 */
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			console.log("to.hash:", to.hash);
			var hash = to.hash;
			var offsetVar = { x: 0, y: 80 };
			if (hash === "#businessfield") {
				offsetVar.y = 200;
			} else if (hash === "#aboutcompany") {
				offsetVar.y = 180;
			} else if (hash === "#aboutteam") {
				offsetVar.y = 160;
			} else {
				document.getElementById("app").scrollIntoView();
			}
			return {
				selector: to.hash,
				offset: offsetVar
			};
		} else {
			document.getElementById("app").scrollIntoView();
		}
	}
});
